import React, { useState, createContext } from "react";
import Layout from "./layout/Layout";
import StandardErrorBoundary from "./error/StandardErrorBoundary";

const App = () => {
  // const [domain, setDomain] = useState("https://api-v1.gishniz.link");
  const [domain, setDomain] = useState("https://api.gishniz.com");

  const [imageState, setImageState] = useState(null);
  const imageValue = { imageState, setImageState };

  return (
    <StandardErrorBoundary>
      <DomainContext.Provider value={domain}>
        <ImageContext.Provider value={imageValue}>
          <Layout />
        </ImageContext.Provider>
      </DomainContext.Provider>
    </StandardErrorBoundary>
  );
};

export const DomainContext = createContext();

export const ImageContext = createContext({
  imageState: "",
  setImageState: () => {},
});

export default App;
